import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../../../Context";
import { ATTENDANCE_DASHBOARD_LINK, ATTENDANCE_ACTION } from "../../../routes";

const SubMenuModal = ({ subMenuFields, title, setShowPopup }) => {
  const navigate = useNavigate();

  const totalItems = subMenuFields.length;
  const isOddCount = totalItems % 2 === 1;

  const handleClick = (link) => {
    if (link) {
      navigate(link);
    }
    setShowPopup(false);
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-20 z-40 flex items-center justify-center duration-200 "
      onClick={() => setShowPopup(false)}
    >
      <div
        className="bg-white p-6 rounded-3xl shadow-lg w-11/12 md:w-1/3 grid grid-cols-2 gap-4 z-50"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="col-span-2 text-center text-xl font-semibold text-secondary mb-2">
          {title}
        </div>

        {subMenuFields.map(({ label, icon, link }, index) => {
          const isLastItem = index === totalItems - 1;
          const shouldCenter = isOddCount && isLastItem;

          return (
            <div
              key={label}
              onClick={() => handleClick(link)} // <-- this is key
              className={`
              cursor-pointer hover:bg-gray-100 rounded-lg py-4
              flex justify-center
              ${shouldCenter ? "col-span-2" : ""}
            `}
            >
              <div className="flex flex-col items-center">
                <div
                  className={`w-14 h-14 md:w-16 md:h-16 bg-opacity-80 rounded-full flex items-center justify-center shadow-xl text-white`}
                >
                  {icon}
                </div>
                <span className="text-sm font-medium mt-2 text-center text-secondary">
                  {label}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SubMenuModal;
